import { translate } from './translations'

export function initFacebookShare(fbAppId) {

  window.fbAsyncInit = function() {
    //SDK loaded, initialize it
    FB.init({
        appId      : fbAppId,
        xfbml      : true,
        version    : 'v2.6'
    });
    //JS SDK initialized, now you can use it
    FB.XFBML.parse();
  };
  
  //load the JavaScript SDK
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

}

// layout variables
const gutter = 28; // insta 28
const totalContentWidth = 900; // insta 935
const leftColWidth = 550; // insta 614
const maxMobileWidth = 800;
const mobileHeaderImgHeight = 36;
const mobileHeaderImgPadding = 10;
// fixed scrolling variables
const contentMarginTop = 88;
const contentPaddingTop = gutter;
const contentPaddingBottom = 0;

export const layoutVariables = {
  gutter: gutter,
  totalContentWidth: totalContentWidth,
  leftColWidth: leftColWidth,
  rightColWidth: totalContentWidth - leftColWidth - gutter,
  maxMobileWidth: maxMobileWidth,
  mobileHeaderImgHeight: mobileHeaderImgHeight,
  mobileHeaderImgPadding: mobileHeaderImgPadding,
  mobileHeaderHeight: mobileHeaderImgHeight + (mobileHeaderImgPadding*2),
  contentMarginTop: contentMarginTop,
  contentPaddingTop: contentPaddingTop,
  contentPaddingBottom: contentPaddingBottom,
  contentPaddingPlusMargin: contentMarginTop + contentPaddingTop + contentPaddingBottom,
}

export const handleScroll = (e) => {
  var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  var scrollPosition = window.pageYOffset;
  var header = document.getElementById('header');
  var content = document.querySelector('.content');
  var headerHeight = header.offsetHeight;
  var contentPaddingTop = parseInt(getComputedStyle(content).paddingTop.slice(0, -2))
  var contentPaddingBottom = parseInt(getComputedStyle(content).paddingBottom.slice(0, -2))
  var leftCol = document.getElementById('contentLeft');
  var rightCol = document.getElementById('contentRight');
  var leftColHeight = leftCol.offsetHeight;
  var rightColHeight = rightCol.offsetHeight;
  var leftColWidth = leftCol.offsetWidth;
  var rightColWidth = rightCol.offsetWidth;
  var leftColoffsetLeft = leftCol.getBoundingClientRect().left;
  var rightColoffsetLeft = rightCol.getBoundingClientRect().left;
  var contentPaddingPlusMargin = headerHeight + contentPaddingTop
  var colTop = contentPaddingPlusMargin - contentPaddingBottom;

  if (leftColHeight > rightColHeight) {
    if ((windowHeight + scrollPosition) >= (rightColHeight + contentPaddingPlusMargin)) {
      if (windowHeight - contentPaddingPlusMargin < rightColHeight) {
        colTop = windowHeight - rightColHeight - contentPaddingBottom;
      }
      rightCol.style.position = 'fixed';
      rightCol.style.top = colTop + 'px';
      rightCol.style.removeProperty('right');
      rightCol.style.left = rightColoffsetLeft + 'px';
      rightCol.style.width = rightColWidth + 'px';
    } else {
      rightCol.style.position = 'absolute';
      rightCol.style.removeProperty('top');
      rightCol.style.right = 0;
      rightCol.style.removeProperty('left');
    }
  } else {
    if ((windowHeight + scrollPosition) >= (leftColHeight + contentPaddingPlusMargin)) {
      if (windowHeight - contentPaddingPlusMargin < leftColHeight) {
        colTop = windowHeight - leftColHeight - contentPaddingBottom;
      }
      leftCol.style.position = 'fixed';
      leftCol.style.top = colTop + 'px';
      leftCol.style.left = leftColoffsetLeft + 'px';
      leftCol.style.width = leftColWidth + 'px';
    } else {
      leftCol.style.position = 'static';
      rightCol.style.removeProperty('top');
      rightCol.style.removeProperty('left');
    }
  }
};

export function getMessage(msgType, didEscape, activeRoom, groupType, roomMessaging, language = 'en') {
  var msgSuffix;
  groupType == 'single' ? (
    didEscape ? msgSuffix = '_success' : msgSuffix = '_fail'
  ) : (
    msgSuffix = '_event'
  );

  let msgTypeArray = [
    roomMessaging[activeRoom][language][msgType + msgSuffix],
    roomMessaging[activeRoom][language][msgType + "_default"],
    roomMessaging["0"][language][msgType + msgSuffix],
    roomMessaging["0"][language][msgType + "_default"],
    roomMessaging[activeRoom]['en'][msgType + msgSuffix],
    roomMessaging[activeRoom]['en'][msgType + "_default"],
    roomMessaging["0"]['en'][msgType + msgSuffix],
    roomMessaging["0"]['en'][msgType + "_default"],
  ]

  if (groupType == 'multi') {
    msgTypeArray = [
      roomMessaging["0"][language][msgType + msgSuffix],
      roomMessaging["0"]['en'][msgType + msgSuffix],
    ]
  }

  var finalMsg;
  for (var i = 0; i < msgTypeArray.length; i++) {
    if (msgTypeArray[i]) {
      if (msgTypeArray[i].trim()) {
        var finalMsg = msgTypeArray[i];
        break;
      }
    }
  }
  return finalMsg;
}

export const buildColumns = (widgetList, screen, colNum) => {
  let x = widgetList.reduce((p, c) => {
    if (c[1][screen + "_col"] === colNum && c[1]["show"] === true && c[0].toString().substring(0, 6) !== "delete") {
      p.push(c);
    }
    return p;
  }, []);
  let sortedX = x.sort(function(a, b) {
    a = a[1][screen + "_order"];
    b = b[1][screen + "_order"];
    return a < b ? -1 : (a > b ? 1 : 0);
  });
  return sortedX;
}

export const getTabsContext = (tabsInput, group_size, language) => {
  const all_groups_label = translate("All Groups", language)
  const by_size_label = translate("Groups of ", language) + group_size
  const all_time_label = translate("All Time", language)
  const last_30_days_label = translate("Last 30 Days", language)


  switch (tabsInput.join(" ")) {

    case "true true true false":
      return {
        lb_label: {
          show: false,
          text: "",
        },
        headers: {
          show: true,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '10px',
        all_groups_all_time: {
          flex: '1',
          label: all_time_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '2',
          label: all_time_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
      }

    case "true true false true":
      return {
        lb_label: {
          show: false,
          text: "",
        },
        headers: {
          show: true,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '10px',
        all_groups_all_time: {
          flex: '1',
          label: all_time_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: all_time_label,
        },
        by_group_size_last_30_days: {
          flex: '2',
          label: last_30_days_label,
        },
      }

    case "true false true true":
      return {
        lb_label: {
          show: false,
          text: "",
        },
        headers: {
          show: true,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '10px',
        all_groups_all_time: {
          flex: '2',
          label: all_time_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: all_time_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
      }

    case "false true true true":
      return {
        lb_label: {
          show: false,
          text: "",
        },
        headers: {
          show: true,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '10px',
        all_groups_all_time: {
          flex: '1',
          label: all_time_label,
        },
        all_groups_last_30_days: {
          flex: '2',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: all_time_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
      }

    case "true true false false":
      return {
        lb_label: {
          show: false,
          text: "",
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_time_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: all_time_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
      }

    case "false false true true":
      return {
        lb_label: {
          show: true,
          text: by_size_label,
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_time_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: all_time_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
      }

    case "true false true false":
      return {
        lb_label: {
          show: false,
          text: "",
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_groups_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: by_size_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
      }

    case "false true false true":
      return {
        lb_label: {
          show: true,
          text: last_30_days_label,
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: last_30_days_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_groups_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: all_groups_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: by_size_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: by_size_label,
        },
      }

    case "true false false false":
      return {
        lb_label: {
          show: false,
          text: last_30_days_label,
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: last_30_days_label,
          by_size_show: true,
        },
        tabs_show: false,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_groups_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: all_groups_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: by_size_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: by_size_label,
        },
      }

    case "false true false false":
      return {
        lb_label: {
          show: false,
          text: last_30_days_label,
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: last_30_days_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_groups_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: by_size_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: by_size_label,
        },
      }

    case "false false true false":
      return {
        lb_label: {
          show: false,
          text: last_30_days_label,
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: last_30_days_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_groups_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: by_size_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: by_size_label,
        },
      }

    case "false false false true":
      return {
        lb_label: {
          show: false,
          text: last_30_days_label,
        },
        headers: {
          show: false,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: last_30_days_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '13px',
        all_groups_all_time: {
          flex: '1',
          label: all_groups_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: by_size_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: by_size_label + " - " + last_30_days_label,
        },
      }

    default:
      return {
        lb_label: {
          show: false,
          text: "",
        },
        headers: {
          show: true,
          all_groups_label: all_groups_label,
          all_groups_show: true,
          by_size_label: by_size_label,
          by_size_show: true,
        },
        tabs_show: true,
        tabs_font_size: '10px',
        all_groups_all_time: {
          flex: '1',
          label: all_time_label,
        },
        all_groups_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
        by_group_size_all_time: {
          flex: '1',
          label: all_time_label,
        },
        by_group_size_last_30_days: {
          flex: '1',
          label: last_30_days_label,
        },
      }

  }
}
